import { FuseScrollbars } from "@fuse";
import { AppBar, MuiThemeProvider, Toolbar, withStyles } from "@material-ui/core";
import Logo from "app/Configs/fuse-layouts/shared-components/Logo";
import NavbarMobileToggleButton from "app/Configs/fuse-layouts/shared-components/NavbarMobileToggleButton";
import AgendaPainel from "app/Core/Components/AgendaPainel/AgendaPainel";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import ChecklistEmpresa from "app/Core/Components/ChecklistEmpresa/ChecklistEmpresa";
import Favorito from "app/Core/Components/Favorito/Favorito";
import Navigation from "app/Core/Components/Navigation/Navigation";
import CentralNotificacoesNavButton from "app/Core/Funcionalidade/Comunicador/Gerenciadores/CentralNotificacoes/NavButton";
import { checkPlano } from "app/Core/Helpers";
import Planos from "app/Planos/index.json";
import clsx from "clsx";
import _ from "lodash";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
   separator: {
      width: 1,
      height: 48,
      backgroundColor: theme.palette.divider,
   },
   toolbarNovo: {
      backgroundColor: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
   },
   navigation: {
      display: "block",
      "@media (max-width: 1280px)": {
         display: "none",
      },
   },
   navigationMobile: {
      display: "block",
      "@media (min-width: 1281px)": {
         display: "none",
      },
   },
   toolbarFavorito: {
      background: theme.palette.type === "dark" ? "#303030" : "#CCC",
      display: "block",
      "@media (min-width: 1281px)": {
         display: "none",
      },
   },
});

const ToolbarLayout2 = ({ classes, settings, toolbarTheme, empresa = null, sistemas = {} }) => {
   const layoutConfig = settings.layout.config;

   return (
      <React.Fragment>
         <MuiThemeProvider theme={toolbarTheme}>
            <AppBar id="fuse-toolbar" className={clsx(classes.toolbarNovo, "flex relative z-10")} color="default">
               <Toolbar className="container p-0 min-h-48 h-48">
                  <div className="flex flex-no-shrink items-center pl-12 pr-16">
                     <Logo />
                  </div>
                  <div className={classes.navigation}>
                     <FuseScrollbars className="flex h-full items-center overflow-x-auto">
                        <Favorito />
                     </FuseScrollbars>
                  </div>
                  <div className={"flex-1"} />
                  {!_.isNull(empresa) && !_.isUndefined(sistemas[empresa]) && !_.isUndefined(sistemas[empresa].dados.configuracao) &&
                     _.findIndex(sistemas[empresa].dados.configuracao, { "chave": "ACESSO_CENTRAL_NOTIFICACAO" }) !== -1 &&
                     _.find(sistemas[empresa].dados.configuracao, { "chave": "ACESSO_CENTRAL_NOTIFICACAO" }).valor.toLowerCase() === "true" &&
                     <CentralNotificacoesNavButton />
                  }
                  {checkPlano(Planos.help.primeirosPassos, settings) && !_.isNull(empresa) &&
                     <ChecklistEmpresa
                        xappRouteParams={{ "empresa": empresa }}
                     />
                  }
                  {checkPlano(Planos.agendamento.lembretes, settings) &&
                     <AgendaPainel />
                  }
                  <div className={classes.separator} />
                  <div className={classes.navigation}>
                     <FuseScrollbars className={clsx("flex h-full items-center")}>
                        <Navigation className={"w-full"} layout="horizontal" dense />
                     </FuseScrollbars>
                  </div>

                  {layoutConfig.navbar.display && (
                     <div className={classes.navigationMobile}>
                        <NavbarMobileToggleButton className="p-0">
                           <XAPPButton type="Icon" className="" onClick={() => { }} icon={"menu"} key={"iconToggleMenuMobile"} />
                        </NavbarMobileToggleButton>
                     </div>
                  )}
               </Toolbar>
               <Toolbar className={clsx(classes.toolbarFavorito, "container p-0 min-h-40 h-40")}>
                  <FuseScrollbars className="flex h-full w-full items-center overflow-x-auto">
                     <Favorito />
                  </FuseScrollbars>
               </Toolbar>
            </AppBar>
         </MuiThemeProvider>
      </React.Fragment>
   );
};

function mapStateToProps({ fuse, auth }) {
   return {
      settings: fuse.settings.current,
      toolbarTheme: fuse.settings.toolbarTheme,
      empresa: fuse.navigation.empresa,
      sistemas: auth.user.data.settings.sistemas,
   };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(ToolbarLayout2)));
